module.exports = __webpack_public_path__ + "public/images/rating-leader.7cbd2a14a71ec03a9d0b6e7dd1c8a59b.svg";